import type { RxJsonSchema } from 'rxdb'
import type { StarredItem } from '@/lib/types/starred'

export type StarredDocument = StarredItem

export const starredSchema: RxJsonSchema<StarredDocument> = {
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: {
      type: 'string',
      maxLength: 36,
    },
    envId: {
      type: 'string',
      maxLength: 36,
    },
    userId: {
      type: 'string',
      maxLength: 36,
    },
    entityType: {
      type: 'string',
      enum: ['project', 'saved_filter', 'cycle', 'page', 'task'],
      maxLength: 20,
    },
    entityId: {
      type: 'string',
      maxLength: 36,
    },
    sortOrder: {
      type: ['string', 'null'],
      maxLength: 100,
    },
    isDeleted: {
      type: 'boolean',
      default: false,
    },

    // Audit fields
    createdOn: {
      type: 'number',
      minimum: 0,
      maximum: 9999999999999,
      multipleOf: 1,
    },
    createdBy: {
      type: 'string',
      maxLength: 36,
    },
    updatedOn: {
      type: 'number',
      minimum: 0,
      maximum: 9999999999999,
      multipleOf: 1,
    },
    updatedBy: {
      type: 'string',
      maxLength: 36,
    },
    deletedOn: {
      type: ['number', 'null'],
      minimum: 0,
      maximum: 9999999999999,
      multipleOf: 1,
    },
    deletedBy: {
      type: ['string', 'null'],
      maxLength: 36,
    },

    // RxDB replication metadata
    updatedAt: {
      type: 'number',
      minimum: 0,
      maximum: 9999999999999,
      multipleOf: 1,
    },
  },
  required: [
    'id',
    'envId',
    'userId',
    'entityType',
    'entityId',
    'isDeleted',
    'createdOn',
    'createdBy',
    'updatedOn',
    'updatedBy',
  ],
  indexes: [
    'envId',
    'updatedOn',
    ['envId', 'userId', 'isDeleted'],
    ['envId', 'userId', 'entityType', 'isDeleted'],
    ['entityType', 'entityId'],
  ],
}

export const starredMigrationStrategies = {}
